@if (dataLineList) {
  <div class="grid dashboard">
    @for (dataline of dataLineList; track dataline; let even = $even; let odd = $odd; let max = $last) {
      <div class="col-12 linespad">
        <linegrid [ngClass]="{ odd: odd, even: even }" [dataLine]="dataline"></linegrid>
        @if (!max) {
          <hr class="linespad"/>
        }
      </div>
    }
  </div>
}